var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 36,
    viewBox: "0 0 47 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6202 13.6464C15.5848 13.6464 15.5521 13.6277 15.5341 13.5973L14.0891 11.1509C14.0497 11.0842 14.0978 11 14.1752 11H33.6343C33.7117 11 33.7598 11.0842 33.7204 11.1509L32.2755 13.5973C32.2575 13.6277 32.2247 13.6464 32.1894 13.6464H15.6202Z",
    fill: "#0052D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6523 17.1629C17.6523 17.1607 17.6517 17.1585 17.6506 17.1566L16.179 14.6796C16.1394 14.613 16.1874 14.5286 16.265 14.5286H31.545C31.6224 14.5286 31.6705 14.6128 31.6311 14.6794L30.1861 17.1258C30.1681 17.1563 30.1354 17.175 30.1 17.175H17.6645C17.6578 17.175 17.6523 17.1696 17.6523 17.1629V17.1629Z",
    fill: "#00A870"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7986 20.6882C19.7633 20.6882 19.7305 20.6695 19.7125 20.639L18.2676 18.1926C18.2282 18.1259 18.2763 18.0417 18.3537 18.0417H29.4702C29.5479 18.0417 29.5959 18.1263 29.5561 18.193L28.0968 20.6394C28.0788 20.6697 28.0462 20.6882 28.011 20.6882H19.7986Z",
    fill: "#F2995F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8724 24.2013C21.8372 24.2013 21.8045 24.1827 21.7865 24.1523L20.3422 21.7214C20.3026 21.6547 20.3506 21.5703 20.4282 21.5703H27.366C27.4435 21.5703 27.4916 21.6547 27.452 21.7214L26.0077 24.1523C25.9897 24.1827 25.957 24.2013 25.9217 24.2013H21.8724Z",
    fill: "#E34D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9b6cce6178ed0a74bf4f13c8d5671856.svg";
export { ForwardRef as ReactComponent };